import React from 'react';

import { styled } from '@mui/material';
import { SocialIcon } from 'react-social-icons';
import { graphql, useStaticQuery } from 'gatsby';

// root: {
//   paddingTop: theme.spacing(1),
//   paddingBottom: theme.spacing(1),
//   overflow: 'hidden',
// },

const StyledSocialIcon = styled(SocialIcon)(({ theme }) => ({
  '& .social-svg-icon': {
    fill: `${theme.palette.common.white} !important`,
  },
  '&:hover, &:focus': {
    color: theme.palette.secondary.main,
    '& .social-svg-icon': {
      fill: `${theme.palette.secondary.main} !important`,
    },
  },
  '&:first-of-type': {
    marginLeft: '-20px',
  },
  margin: '-9px 0 0 -8px',
}));

function SocialLinks() {
  const data = useStaticQuery(graphql`
    query {
      allStrapiSocialMedia {
        nodes {
          socialMedia {
            brand
            id
            url
          }
        }
      }
    }
  `);

  return (
    <>
      {data.allStrapiSocialMedia.nodes[0].socialMedia.map((socialLink) => {
        const { id, brand, url } = socialLink;
        return <StyledSocialIcon label={brand} key={id} url={url} bgColor="transparent" />;
      })}
    </>
  );
}

export default SocialLinks;
